module.exports = __webpack_public_path__ + "static/media/TimeTrain_Dexterity.b46c70df.gif";